import { isEmpty, isEqual } from "lodash";
import Base from "./_Base";
import * as fieldParser from "./parses/field";
import { FormBridgeMaster as formBridgeMaster } from "@ali/gov-form-bridge";

window.formBridgeMaster = formBridgeMaster;
// 出生地变更获取医院列表
// iframeRequest: [
//   {
//     requestId: 'UUID',
//     url: "https://www.taobao.com",
//     params: {
//       // 目标 id
//       entityCode:"areaHospital",
//       bizCode: "${self.csdd}.value.last"
//     },
//     event: "${self.csdd}:change",
//     field: {
//       id: "self.yljgmc",
//       prop: "dataSource.options"
//     }
//   }
// ]

export default class IframeRequest extends Base {
  _type = "iframeRequest";

  /**
   * 解析影响字段
   * @param {object} field 影响字段
   */
  _parseField(field) {
    return fieldParser.parse(field, {
      fieldApi: this.fieldApi,
      funcs: this.funcs,
    });
  }

  // iframe调用保存草稿
  saveDraft() {
    const { saveFunc } = window;
    if (saveFunc) {
      saveFunc('saveDraft');
    }
  }

  parse = () => {
    const { iframeRequest: dataSource } = this.schema;
    if (!dataSource || !dataSource.length) return;
    dataSource.forEach((config) => {
      const {
        requestId,
        url,
        options = {},
        // type,
        // disableParamsEvent, // 禁止从 params 中解析出事件
      } = config;
      // eslint-disable-next-line new-cap
      const bridgeMaster = new formBridgeMaster({ key: requestId });
      const parsedEvent = this._parseEvent(config.event);
      const parsedParams = this._parseParams(config.params);
      let parsedAction = {};
      if (config.field) {
        parsedAction = this._parseField(config.field);
      } else if (config.target) {
        parsedAction = this._parseTarget(config.target);
      }
      const { preHandler, handler } = parsedAction;
      // const event = disableParamsEvent
      //   ? parsedEvent.event
      //   : this._mergeEvent(parsedEvent.event, parsedParams.event);
      const event = parsedEvent.event;

      const promise = () => {
        return new Promise((resolve, reject) => {
          bridgeMaster.onClientReady(() => {
            resolve();
          });
        });
      };

      this._addListener({
        uuid: requestId,
        config,
        event,
        func: async (value, changedKey) => {
          const params = parsedParams.handler(config);
          if (!params) return;

          // 预处理
          // eslint-disable-next-line no-unused-expressions
          preHandler && preHandler();

          bridgeMaster.open(url, options);

          if (!bridgeMaster._isReady) {
            bridgeMaster.onReady(() => {
              bridgeMaster.onReceiveData((data) => {
                // 详情页则不会更新iframe返回修改的值
                if (this.isDetail) {
                  return;
                }

                if (data) {
                  if (isEqual(data, { saveDraft: true })) {
                    this.saveDraft();
                    return;
                  }
                  if (data.saveDraft) {
                    setTimeout(() => {
                      this.saveDraft();
                    }, 500);
                    delete data.saveDraft;
                  }
                  // 运行时构建响应数据并传入
                  return handler({
                    res: data,
                    failed: isEmpty(data),
                    changedKey,
                  });
                }

                return handler({ res: undefined, failed: true });
              });
            });
          }

          // client ready 之后，向 client 发送数据
          promise().then(() => {
            // 将query必要参数传递给iframe
            const p = Object.assign(
              {
                ...(this.params || {}), // 受理透传过来的参数
                detail: this.isDetail,
                bizChannel: (this.params || {}).bizChannel || "pc",
              },
              params // 表单schema配置的params
            );
            bridgeMaster.postData(p);
          });
        },
      });
    });
  };
}
